import React from 'react';
import { Column } from 'react-table';
import { withArrow } from 'components/Table/helpers';
import { DATE_TIME_FORMAT, getFormattedDateTime } from 'helpers/datetime';

export const config = (): Column[] => [
  {
    Header: withArrow('title.date'),
    accessor: 'createdDate',
    resizable: false,
    width: 200,
    Cell: row => (
      <span>{getFormattedDateTime(row.value, DATE_TIME_FORMAT)}</span>
    ),
  },
  {
    Header: withArrow('title.email.subject'),
    accessor: 'subject',
    resizable: false,
    sortable: false,
    minWidth: 200,
  },
];
